<template>
    <div>
        <div class="form-group ">
            <label for="matricula">Transitario</label>
            <select class="select-input mt-1 " v-model = form.transitario>
                <option disabled selected>Seleccionar transitario</option>
                <option  v-for="(transitario, index) in transitarios" :key="index" >{{transitario}}</option>
            </select>
        </div>
        <div class="form-group">
            <label for="date">Franja horaria</label>
            <div class="timeZone">
               <input :type="typeDate" class="general-input dateTime-label mt-1" @click="changeTypeDate()"  v-bind:class="{ 'date-input': typeDate=='date'}" placeholder = 'Seleccionar fecha'    v-model = form.containerReceiptDate >
             <input :type="typeTimeSince" class=" general-input time  mt-3"  @click="changeTypeTimeSince()" v-bind:class="{ 'time-input': typeTimeSince=='time'}"  placeholder = 'Hora inicio'  v-model = form.since >
            <input :type="typeTimeUntil" class=" general-input  time  mt-3  float-right"  @click="changeTypeTimeUntil()"  v-bind:class="{ 'time-input': typeTimeUntil=='time'}"  placeholder = 'Hora fin'  v-model = form.until >
            </div>
        </div>

        <ContainerUploadDoc id="1" name='Carta de porte' reference="dangerousMerchandiseFile" eventType = "carta_de_porte"></ContainerUploadDoc>

        <div class="form-group mt-4">
            <button type="button" class="btn-general" @click="createReservation()" :disabled = "!completedPart2">
                SOLICITAR NUEVA RESERVA
            </button>
        </div>

        <confirmModal v-if="modalVisible" message="Reserva solicitada. Se notificará a Transitario." link="/containers"></confirmModal>
    </div>
</template>

<script>
import ContainerUploadDoc from '@/components/containerViews/ContainerUploadDoc'
import confirmModal from '@/components/confirmModal'
import { newReservation, setData, updateAction,uploadDoc } from '@/services/api'
import { mapGetters } from 'vuex'
// @ is an alias to /src

export default {
  name: 'createNewPart2',
  components: {
        ContainerUploadDoc,
        confirmModal
    },
  data() {
    return {
        modalVisible: false,
        typeDate: 'text',
        typeTimeSince: 'text',
        typeTimeUntil: 'text',
        transitarios: ['Ag. Marítima Blázquez', 'Transitario 2', 'Transitario 3'],
        form: {
            transitario: 'Seleccionar transitario',
            containerReceiptDate: '', // 2020-07-08
            since: '',
            until: '',
            // dangerousMerchandiseFile: ''
            /*actions: [
              {
                id: 0,
                modified: "",
                name: "SOLICITUD DE RESERVA",
                status: "completed",
                role: null,
                stage: {
                  "id": 1,
                  "name": "Apertura de expediente"
                },
                type: "action"
              },
              {
              id: 2,
              name: "CREACIÓN DE EXPEDIENTE",
              status: 'pending',
              modified: "",
              stage: {
                id: 1,
                name: "Apertura de expediente"
                },
              type: "action"
              }  
            ],*/
        },
        objectToSend: {
          internalId: "TEST009",
          state: "Solicitada",
          documentos: []
        },
        documentToSend: {
          binary: "",
          formato: "",
          blockchain: "",
          id: 1,
          nombre: "",
          tipo: ""
        },
        binaryContent: ''
    }
  },
  computed: { 
    ...mapGetters("container",{
      reservation_data: 'reservation_data',
      documents: 'documents',
    }), 
    completedPart2: function () {
        if(this.form.transitario && this.form.containerReceiptDate && this.form.since && this.form.until){
          return true
        }else {
          return false
        }
      }
  },
  mounted () {
   
  },
  methods: { 
      getTransitarios (){

      },
      createReservation (){
        var now = new Date();
        var nowString =  now.getDate() + (now.getMonth() +1) + now.getFullYear() + '_' + now.getHours() + now.getMinutes() + now.getSeconds()
        var formatNowString = now.getDate() + '/' +(now.getMonth() +1) + '/' + now.getFullYear() + ' ' + now.getHours() + ':' + now.getMinutes()
        this.form.internalId = 'Exp_' + nowString
        var objToSendFull = Object.assign(this.form, this.reservation_data);
        //this.$store.commit('container/set_reservation_data', objToSend)

        var objToSend = {
          "internalId": objToSendFull.internalId,
          "containerNumber": objToSendFull.containerNumber,
          "containerSize": objToSendFull.containerSize,
          "destination": objToSendFull.destination,
          "containerReceiptDate": objToSendFull.containerReceiptDate,
          "since": objToSendFull.since,
          "until": objToSendFull.until,
          "state": "Solicitada"
        }
        setData('expedientes/', objToSend).then(res => {
          if(res.status == 200){
            this.createContainer(objToSendFull, nowString)
            updateAction(objToSendFull.internalId, "SOLICITUD_DE_RESERVA", now, '')
            updateAction(objToSendFull.internalId, "CREACION_DE_EXPEDIENTE", "pending", '')
            //updateAction("TEST003", "SOLICITUD_DE_RESERVA", now)
            //updateAction("TEST003", "CREACION_DE_EXPEDIENTE", "pending")

            if(this.reservation_data.dangerousMerchandise){
              var event = {
                name: objToSendFull.internalId + '_carta_de_porte',
                eventGroup: 'Group 1',
                eventType: this.documents[1].eventType,
                expediente: objToSendFull.internalId,
              }
              setData('events/', event).then(res => {
                var documentType = 'Carta de porte'
                uploadDoc('events/'+ event.name + '/documents',this.documents[1].file,documentType).then(res => {
                  this.$store.commit('container/clear_documents')
                })
              })
            }
          }
        })

         

        // if(this.reservation_data.dangerousMerchandise){
        //    // this.form.dangerousMerchandiseFile = this.documents[1].file
        //     var docToSend = this.documentToSend
    
        //     docToSend.nombre = this.documents[1].file.name
        //     docToSend.tipo = 'Mercancía peligrosa'
        //     docToSend.formato = this.documents[1].file.type

        //     var reader = new FileReader()
        //     reader.readAsDataURL(this.documents[1].file)

        //     reader.onload = function () {
        //       var base64 = reader.result.split(',');
        //       docToSend.binary = base64[1]    
        //       objToSend.documentos.push(docToSend)
        //       setData('expedientes/', objToSend).then(res => {
        //         console.log(res)
        //       })
        //     }
        // }else {
        //   setData('expedientes/', objToSend).then(res => {
        //     console.log(res)
        //   })

        // }

        /*var acciones = 
        [
          {
            "id": 1,
            "name": "SOLICITUD DE RESERVA",
            "status": 'completed',
            "modified":  '2020-09-12 08:15',
            "role": 'cargador',
            "type": 'action',
            "stage": {
              "id": 1,
              "name": "Apertura de expediente"
            }
          },
          {
            "id": 2,
            "name": "CREACIÓN DE EXPEDIENTE",
            "status": 'completed',
            "modified":  '2020-09-12 08:15',
            "role": 'transitario',
            "type": 'action',
            "stage": {
              "id": 1,
              "name": "Apertura de expediente"
            }
          },
          {
            "id": 3,
            "name": "ASIGNACIÓN DE CONTENEDOR",
            "status": 'pending',
            "modified":  '2020-09-12 08:15',
            "role": 'naviera',
            "type": 'action',
            "stage": {
              "id": 1,
              "name": "Apertura de expediente"
            }
          },
          {
            "id": 4,
            "name": "AVISO A TRANSPORTISTA",
            "status": null,
            "modified":  '2020-09-12 08:15',
            "role": 'transitario',
            "type": 'action',
            "stage": {
              "id": 2,
              "name": "Recogida de contenedor vacío"
            }
          },
        ]

        this.$store.dispatch('container/actionsUpdate',acciones)
        .then(resp => { console.log(resp)})
        .catch(err => {console.log(err)})
        */
      },
      createContainer(objToSendFull, nowString) {
        var container_name = "CONT_" + nowString
        var objToSend = {
          "name": container_name,
          "weight": objToSendFull.weight,
          "dangerousMerchandise": objToSendFull.dangerousMerchandise,
          "naturaleza": objToSendFull.merchandiseType
        }
        var url = objToSendFull.internalId + '/containers/'
        //var url = 'TEST003/containers/'
        setData(url, objToSend).then(res => {
          if(res.status == 200){
            this.modalVisible = true
          }
        })
      },
      changeTypeDate(){
        this.typeDate = 'date'
      },
      changeTypeTimeSince(){
        this.typeTimeSince = 'time'
      },
      changeTypeTimeUntil(){
        this.typeTimeUntil = 'time'
      }
  }
}
</script>

<style lang= "scss"  scoped>
 .time{
    display: inline-block;
    width: 43%;
 }
 .timeZone{
   border: 1px solid $input-border;
   border-radius: 0.45rem;
   padding: 20px 10px;
 }

</style>
